import { ReactNode } from 'react';

import classnames from 'classnames';

import { BaseComponentProps } from '../../../types/base-component.types';

import styles from './MetricStrip.module.scss';

type Metric = {
  label: string;
  /** The figure itself: formatted text, or a `ValueChart` counting up to it. */
  value: ReactNode;
};

type ContainerProps = BaseComponentProps & {
  metrics: Metric[];
  /**
   * `board` is the strip as the assessment boards read it: one row of even columns
   * parted by rules, standing on the highlight ground. `panel` is the home cards'
   * own — no ground and no rules, and on a phone the first metric takes a row to
   * itself, because three figures that size never fit across one.
   */
  variant?: 'board' | 'panel';
};

/**
 * A row of labelled figures: label over figure, each column centring its own text
 * and taking the same share of the strip however long the labels run.
 */
function MetricStrip({
  className,
  metrics,
  variant = 'board',
  testId = 'ui-metric-strip',
}: ContainerProps) {
  return (
    <dl
      className={classnames(
        styles['strip'],
        styles[`strip--${variant}`],
        className,
      )}
      data-testid={testId}
    >
      {metrics.map((metric) => (
        <div className={styles['metric']} key={metric.label}>
          <dt className={styles['metric__label']}>{metric.label}</dt>
          <dd className={styles['metric__value']}>{metric.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export { MetricStrip };
export type { Metric };
